import React from "react";
import DashboardSectionBase from "../../../components/DashboardSectionBase";
import Toggle from "../Toggle";
import TextBox from "../TextBox";
import Footer from "../Footer";
import Title from "../Title";

export default ({ title, steps, step, updateState, sobriety, extra, state }) => {

    return(
        <>
            <Title title={title} />
            <DashboardSectionBase title={"Sobriety"} steps={steps} step={step} overflow={true}>
                <div className="margin-top-20px">
                    <Toggle title={"How sober was he/she?"} options={["Excellent", "Good", "Poor"]} updateState={updateState} selected={sobriety} propName={"sobriety"} />
                </div>
                <div className="margin-top-20px">
                    <TextBox title={"Any further details you would like to add (Optional)"} updateState={updateState} propName={"sobrietyExtra"} value={extra} />
                </div>
            </DashboardSectionBase>
            <div className="margin-top-20px">
                <Footer title={"Save & Continue"} icon={require("../../../assets/svgs/continue.svg")} back={true} updateState={updateState} step={step} state={state} propNames={["sobriety"]} />
            </div>
        </>
    );

}